import React from "react";
import ReactDOM from "react-dom";
import { Scrollbars } from "react-custom-scrollbars";
import EApi from "../../api/esports";
import EventsNav from "./EventsNav/EventsNav";
import EventsSearch from "./EventsSearch/EventsSearch";
import EventsList from "./EventsList/EventsList";
import { Route, Switch } from "react-router-dom";
import EventPage from "./EventPage/EventPage";
import { setEvents, setMenu, setType } from "../../actions/eventsActions";
import { setMarkets } from "../../actions/marketsActions";
import { connect } from "react-redux";
import ECoupon from "./ECoupon/ECoupon";
import { UPDATE_PERIOD } from "../../utils";
import makeCancelable from "../../api/cancelable";


class EsportsGame extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      pending: true
    };
    
    this.timer = null;
    this.requests = [];
  }
  
  componentDidMount() {
    this.loadEvents();
    
    this.timer = setInterval(this.loadEvents, UPDATE_PERIOD);
  }
  
  componentWillUnmount() {
    clearInterval(this.timer);
    
    this.requests.forEach(cancel => cancel());
  }
  
  loadEvents = () => {
    const { promise, cancel } = makeCancelable(EApi.loadEvents());
    this.requests.push(cancel);
    
    promise.then((response) => {
      if (response.status === "success") {
        this.props.setEvents(response.events || []);
        this.props.setMarkets(response.markets || []);
        this.props.setMenu(response.menu || {});
      }
      this.setState({ pending: false });
    });
  };
  
  render() {
    const { pending } = this.state;
    const { eventsType, setType } = this.props;
    
    return (
      <div className="esports-game">
        <Switch>
          <Route exact path="/esports">
            <div className="wrapper">
              <div className="esports-game__top">
                <EventsNav onChange={ setType } eventsType={ eventsType }/>
                <EventsSearch/>
              </div>
            </div>
          </Route>
        </Switch>
        <Scrollbars style={ { height: "100%", width: "100%" } } hideTracksWhenNotNeeded={ true }>
          <div className="esports-game__content">
            <Switch>
              <Route exact path="/esports">
                <EventsList eventsType={ eventsType } pending={ pending }/>
              </Route>
              <Route exact path="/esports/:eventId" component={ EventPage } pending={ pending }/>
            </Switch>
            { /*<Footer/>*/ }
          </div>
        </Scrollbars>
        { ReactDOM.createPortal(
          <ECoupon/>,
          document.body
        ) }
      
      </div>
    );
  }
}


export default connect(state => {
  return {
    eventsType: state.events.eventsType
  };
}, {
  setEvents, setMarkets, setMenu, setType
})(EsportsGame);


// WEBPACK FOOTER //
// ./app/components/EsportsGame/EsportsGame.jsx